import { render, staticRenderFns } from "./CreateLanguage.vue?vue&type=template&id=38eebbac&"
import script from "./CreateLanguage.vue?vue&type=script&lang=js&"
export * from "./CreateLanguage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports